import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d6f4f33")

_pushScopeId("data-v-0d6f4f33")
const _hoisted_1 = { class: "digit-frame" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_digit_editbox = _resolveComponent("digit-editbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue, (d, i) => {
      return (_openBlock(), _createBlock(_component_digit_editbox, {
        class: "digit",
        key: `digit-${i}`,
        modelValue: d,
        "onUpdate:modelValue": ($event: any) => (_ctx.onInput(i, $event)),
        onEnter: _ctx.onEnter
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onEnter"]))
    }), 128))
  ]))
})